// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.line-stepper {\n  position: relative !important;\n  top: -42px;\n  z-index: 0;\n  width: 80px;\n  left: 70px;\n}\n.spinner {\n  animation: rotation 2s linear infinite;\n}\n@keyframes rotation {\n0% {\n    transform: rotate(0deg);\n}\n100% {\n    transform: rotate(360deg);\n}\n}\n", ""]);
// Exports
module.exports = exports;
